import React from 'react'
import { useTranslation } from 'react-i18next'
import { Control, FieldErrors } from 'react-hook-form'
import { ControlledTextField } from '../../../form/ControlledTextField'
import { validators } from '../../../../validation/validators'
import { InternalFormValues } from '../form-values'
import { FormGroup } from '../../../form/FormGroup'
import { ControlledHourSeriesSelect } from '../../../form/ControlledHourSeriesSelect'
import {
  HourSeriesCollectionFragment,
  HourSeriesType,
} from '../../../../generated/graphql'

type Props = {
  control: Control<InternalFormValues>
  errors: FieldErrors<InternalFormValues>
  hourSeriesCollections: HourSeriesCollectionFragment[]
}

export function PreheaterForm({
  control,
  errors,
  hourSeriesCollections,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.preheater.relativePower"
          rules={{
            ...validators.required,
            ...validators.efficiency,
          }}
          error={errors.parameters?.preheater?.relativePower}
          label={t('createProvider.forms.preheater.relativePower')}
        />
      </FormGroup>

      <FormGroup>
        <ControlledHourSeriesSelect
          control={control}
          name="hourSeriesIds"
          error={errors.hourSeriesIds}
          label={t('createProvider.forms.preheater.hourSeries')}
          collections={hourSeriesCollections}
          filter={(hourSeries) =>
            hourSeries.type === HourSeriesType.WasteHeating
          }
          allowEmpty
        />
      </FormGroup>
    </>
  )
}
